import React from "react";
import styled from "@emotion/styled";
import { Button, Input, Typography } from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

const { Text } = Typography;

const Toolbar = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    padding: 10px 12px;
  }
`;

const SearchRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const SearchInput = styled(Input)`
  flex: 1 1 220px;
  min-width: 0;
  max-width: 420px;

  @media (max-width: 767px) {
    flex: 1 1 100%;
    max-width: none;
  }
`;

const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    margin-left: 0;
    width: 100%;
  }
`;

export const AGENT_FILTER_SELECT_PROPS = {
  allowClear: true as const,
  size: "small" as const,
  style: { width: "100%" },
};

export const AgentFilterGrid: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 140px), 1fr))",
      gap: 8,
    }}
  >
    {children}
  </div>
);

interface AgentFilterToolbarProps {
  search: string;
  searchPlaceholder: string;
  onSearchChange: (value: string) => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  onRefresh: () => void;
  resultCount: number;
  resultHint?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const AgentFilterToolbar: React.FC<AgentFilterToolbarProps> = ({
  search,
  searchPlaceholder,
  onSearchChange,
  hasActiveFilters,
  onClearFilters,
  onRefresh,
  resultCount,
  resultHint,
  actions,
  children,
}) => (
  <Toolbar>
    <SearchRow>
      <SearchInput
        size="small"
        placeholder={searchPlaceholder}
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
      />
      <ActionGroup>
        {hasActiveFilters && (
          <Button size="small" onClick={onClearFilters}>
            Clear filters
          </Button>
        )}
        <Button size="small" icon={<ReloadOutlined />} onClick={onRefresh}>
          Refresh
        </Button>
        {actions}
      </ActionGroup>
    </SearchRow>

    <AgentFilterGrid>{children}</AgentFilterGrid>

    <Text type="secondary" style={{ fontSize: 12, marginTop: 10, display: "block" }}>
      {resultCount} result{resultCount === 1 ? "" : "s"}
      {resultHint ? ` · ${resultHint}` : ""}
    </Text>
  </Toolbar>
);
